// extracted by css-extract-rspack-plugin
export default {"aliceAppTitle__container":"aliceAppTitle__container__XYVJg","aliceAppTitle__header":"aliceAppTitle__header__liT47","aliceAppTitle_hideAtMobile":"aliceAppTitle_hideAtMobile__bdEeV"};